import "./DashboardPage.css";
import work from "../../assets/image/work.png";
import Highchart from "../../components/Highchart/Highchart";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { ToastContainer } from "react-toastify";
import axios from "axios";
import {
    handelDataState,
    handleErrorState,
} from "../../HandleSlice/HandleSlice";
import Error from "../../components/Error/Error";
import DashboardSkeleton from "../../components/DashboardSkeleton/DashboardSkeleton";
import CustomUpdateToast from "../../components/CustomUpdateToast/CustomUpdateToast";


const Dashboard = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [dashboardData, setDashboardData] = useState({});
    const [installprompt, setInstallprompt] = useState(null);
    const [pwaInstalled, setShowPwaInstalled] = useState(false);
    const [preventFirstRender, setPreventFirstRender] = useState(false);
    const dataState = useSelector((state) => state.hamberger);
    const dispatch = useDispatch();
    const pwaPopup = useRef(null);

    useEffect(() => {
        if (dataState.homeAdminFetchState) {
            loadData();
        }
    }, [dataState.homeAdminFetchState]);

    useEffect(() => {
        window.addEventListener("beforeinstallprompt", (event) => {
            event.preventDefault();
            setInstallprompt(event);
            if (preventFirstRender === true) {
                setInstallprompt(true);
            }
        });

        document.addEventListener("click", (event) => {
            if (event.target === pwaPopup.current) {
                return;
            } else if (event.target.offsetParent !== pwaPopup.current) {
                closeClickHandler()
            }
        });
        return () => {
            window.removeEventListener("click", () => {});
            window.removeEventListener("beforeinstallprompt", () => {});
        };
    }, [installprompt]);

    useEffect(() => {
        const now = new Date();
        const state = JSON.parse(localStorage.getItem("show_PWA_install"));
        if (state) {
            if (state.expiry < now.getTime()) {
                localStorage.removeItem("show_PWA_install");
            } else {
                setShowPwaInstalled(state.value);
            }
        }
    }, [installprompt]);

    const loadData = async () => {
        dispatch(handleErrorState(""))
            setIsLoading(true)
            await axios
                .get("/home-admin")
                .then((res) => {
                    localStorage.setItem(
                        "home_admin_data",
                        JSON.stringify(res.data.schema)
                    );
                    setDashboardData(res.data.schema);
                    // dispatch(handelHeaderAndAsideData(res.data.schema))
                    dispatch(handelDataState(true))
                    setIsLoading(false);
                })
                .catch((e) => {
                    setIsLoading(false);
                });
        setIsLoading(false)
    };

    function closeClickHandler() {
        const now = new Date();
        const item = {
            value: true,
            expiry: now.getTime() + 172800000,
        };
        localStorage.setItem("show_PWA_install", JSON.stringify(item));
        setShowPwaInstalled(true);
    }

    useEffect(() => {
        setPreventFirstRender(true);
    }, [preventFirstRender]);

    return (
        <>
            {isLoading && <DashboardSkeleton />}
            {dataState.errorState === 404 || dataState.errorState === 500 ? (
                <Error error={dataState.errorState} />
            ) : (
                ""
            )}
            <div className="bg-body_background dark:bg-[#152A38] px-[20px] pl-[14px] pt-28 mr-0 w-[calc(100%)] 900:mr-[238px] 900:w-[calc(100%-238px)] transition-all pb-5 pr-[38px]">
                {installprompt && !pwaInstalled && (
                    <div className="fixed bg-[#0000003c] z-[100000] top-0 right-0 w-screen h-screen">
                        <div
                            className="fixed rounded-lg gap-y-2 flex flex-col justify-around items-center p-5 w-[400px] h-[180px] inset-0 m-auto bg-white shadow-lg z-10"
                            ref={pwaPopup}
                        >
                            <div className="w-full flex justify-start text-[20px]">
                                <i
                                    className="fa fa-close text-red-500 cursor-pointer"
                                    onClick={closeClickHandler}
                                />
                            </div>
                            <p className="">
                                {" "}
                                برای تجربه بهتر می توانید نسخه وب اپلیکیشن را نصب کنید{" "}
                            </p>
                            <button
                                className="text-red-500"
                                onClick={() => {
                                    installprompt.prompt();
                                    setShowPwaInstalled(true);
                                }}
                            >
                                {" "}
                                نصب{" "}
                            </button>
                        </div>
                    </div>
                )}
                <div className="">
                    <h2 className="text-[24px] text-h1_text dark:text-white">به پنل مدیریت {dashboardData.form && dashboardData.form.title} خوش آمدید</h2>
                    <p className="text-h2_text text-[14px]"> خانه / داشبورد پروژه</p>
                </div>
                <div className="flex mt-10 gap-5 w-full">
                    <div className="w-[100%]">
                        <div className="relative w-full h-[290px] 340:h-[265px] 560:h-[150px]  lg:h-[130px] 560:flex bg-user_info_backgeround dark:bg-[#3d5743] justify-between pr-[24px] rounded-[12px] pt-[1px]">
                            <div className="mt-[24px]">
                                <h3 className="text-user_info_h text-[1.3123rem] font-bold ">
                                    {dashboardData.form && dashboardData.form.full_name}
                                </h3>
                                <p className="text-user_info_p  mt-[10px] 560:ml-[276px]">
                                    شما <span className="text-white">{dashboardData.form && dashboardData.form.advertiseSucceedTransaction}</span> آگهی درحال بررسی
                                    پرداخت شده برای تأیید دارید ، به جدول آگهی ها رفته و تایید
                                    کنید .
                                </p>
                            </div>
                            <img
                                className="left-[-4px] bottom-[-2px] h-[160px] absolute"
                                src={work}
                                alt=""
                            />
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 w-full gap-5 pt-5">
                            {dashboardData.form &&
                                dashboardData.form.homeDashboard.map((item) => {
                                    return (
                                        <div
                                            className="w-full p-[25px] h-[147px] rounded-[12px] bg-component_background dark:bg-[#29435C]"
                                            key={item.route}
                                        >
                                            <h3 className="text-component_header dark:text-[#D1D4C9] text-[13px] font-bold">
                                                {item.label}
                                            </h3>
                                            <p className="text-component_text mt-1 text-[12px] dark:text-[#a4a0aa]">
                                                کل آگهی های موجود در دارو و درمان
                                            </p>
                                            <div className="flex justify-between">
                                                <div>
                                                    <p className="text-component_header font-bold mt-1 text-[21px] dark:text-[#D1D4C9]">
                                                        {item.count}
                                                    </p>
                                                    <NavLink
                                                        to={item.route}
                                                        className="text-component_text mt-1 text-[12px] dark:text-[#a4a0aa]"
                                                    >
                                                        اطلاعات بیشتر
                                                    </NavLink>
                                                </div>
                                                <div className="w-[45px] h-[45px] bg-[#4d4cb21a] dark:bg-[#58717a] rounded-full mt-5 flex justify-center items-center text-[20px] text-[#7cb997] dark:text-[#80c27b]">
                                                    <i
                                                        className={`fa fa-${item.icon}`}
                                                        aria-hidden="true"
                                                    ></i>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                        </div>
                        <div className="pt-5 px-[20px] bg-white dark:bg-[#29435C] w-[100%] mt-5 rounded-[12px]">
                            {/* <h2 className="font-semibold component_header dark:text-[#D1D4C9]">
                نمودار اطلاعات 30 روز گذشته
              </h2> */}
                            <p className="text-component_text text-[12px] mt-1 dark:text-[#a4a0aa]">
                                اطلاعات تعداد آگهی ها ،تعداد کل پردخت ها و پرداخت های موفق
                            </p>
                            <div className="mt-[45px] pb-[45px] w-full ">
                                <Highchart dashboardData={dashboardData.chart} />
                            </div>
                        </div>
                        <div className="pt-5 px-[20px] bg-white dark:bg-[#29435C] w-full mt-5 rounded-[12px]">
                            <h2 className="font-semibold text-component_header dark:text-[#D1D4C9]">آگهی ها</h2>
                            <p className="text-component_text text-[12px] mt-1 dark:text-[#a4a0aa]">
                                آخرین نظرات ارائه شده درحال بررسی که باید تأیید شود.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={true}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <CustomUpdateToast/>
        </>
    );
};

export default Dashboard;
